import { render } from "./CompanyView.vue?vue&type=template&id=e469870a&ts=true"
import script from "./CompanyView.vue?vue&type=script&lang=ts"
export * from "./CompanyView.vue?vue&type=script&lang=ts"

import "./CompanyView.vue?vue&type=style&index=0&id=e469870a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__